import { render, staticRenderFns } from "./videoCallSurveillance.vue?vue&type=template&id=42ecb790&scoped=true"
import script from "./videoCallSurveillance.vue?vue&type=script&lang=js"
export * from "./videoCallSurveillance.vue?vue&type=script&lang=js"
import style0 from "./videoCallSurveillance.vue?vue&type=style&index=0&id=42ecb790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ecb790",
  null
  
)

export default component.exports